import { useCallback, useState } from 'react'

export function useToggle(initialIsToggled = false, canToggle = true) {
  const [isToggled, setIsToggled] = useState(initialIsToggled)

  const toggle = useCallback(() => {
    if (canToggle) setIsToggled(!isToggled)
  }, [isToggled, canToggle])

  return { isToggled, toggle }
}
